"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftClaimFieldMapping = exports.DraftClaimFieldName = void 0;
var DraftClaimFieldName;
(function (DraftClaimFieldName) {
    DraftClaimFieldName["draftClaimRecordID"] = "draftClaimRecordID";
    DraftClaimFieldName["approvedLenderCode"] = "approvedLenderCode";
    DraftClaimFieldName["approvedLenderName"] = "approvedLenderName";
    DraftClaimFieldName["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    DraftClaimFieldName["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    DraftClaimFieldName["claimTypeIndicator"] = "claimTypeIndicator";
    DraftClaimFieldName["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    DraftClaimFieldName["firstName"] = "firstName";
    DraftClaimFieldName["lastName"] = "lastName";
    DraftClaimFieldName["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    DraftClaimFieldName["typeOfClaim"] = "typeOfClaim";
})(DraftClaimFieldName = exports.DraftClaimFieldName || (exports.DraftClaimFieldName = {}));
var DraftClaimFieldMapping;
(function (DraftClaimFieldMapping) {
    DraftClaimFieldMapping["draftClaimRecordID"] = "draftClaimRecordID";
    DraftClaimFieldMapping["approvedLenderCode"] = "lender.approvedLenderCode";
    DraftClaimFieldMapping["approvedLenderName"] = "lender.approvedLenderName";
    DraftClaimFieldMapping["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    DraftClaimFieldMapping["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    DraftClaimFieldMapping["claimTypeIndicator"] = "claimTypeIndicator";
    DraftClaimFieldMapping["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    DraftClaimFieldMapping["firstName"] = "operation.submitter.firstName";
    DraftClaimFieldMapping["lastName"] = "operation.submitter.lastName";
    DraftClaimFieldMapping["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    DraftClaimFieldMapping["typeOfClaim"] = "detail.typeOfClaim";
})(DraftClaimFieldMapping = exports.DraftClaimFieldMapping || (exports.DraftClaimFieldMapping = {}));
